module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(_vm.actividades.length) ? _c('v-timeline', {
    attrs: {
      "dense": _vm.$vuetify.breakpoint.smAndDown
    }
  }, _vm._l((_vm.actividades), function(o, index) {
    return _c('v-timeline-item', {
      key: index + o,
      staticClass: "animated faster pb-3",
      attrs: {
        "small": "small",
        "right": o.origen === '' || o.origen === null,
        "left": o.origen === 'empresa'
      }
    }, [(!_vm.isMovil) ? _c('span', {
      attrs: {
        "slot": "opposite"
      },
      slot: "opposite"
    }, [_c('small', {
      staticClass: "font-size-11 text-muted"
    }, [_vm._v(_vm._s(o.fechaLegible))])]) : _vm._e(), _c('item-time-line', {
      attrs: {
        "actividad": o,
        "group": o.group
      },
      on: {
        "update": _vm.fetchActividades
      }
    })], 1)
  }), 1) : _vm._l((5), function(a) {
    return _c('div', [_c('v-row', [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line",
        "max-width": "350"
      }
    })], 1), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    })], 1), _c('v-row', [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-three-line",
        "max-width": "350"
      }
    })], 1)], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a20d2dc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_timeline_actividades_ticket.vue
// module id = 487
// module chunks = 1